<script>
import TableroHeader from "@/components/Lego/TableroHeader.vue";
import TableroKanban from "@/components/Lego/TableroKanban.vue";
import TableroGantt from "@/components/Lego/TableroGantt.vue";
export default {
  props: {
    boardId: {
      required: true,
    },
    personaId: {
      required: true,
    },
  },
  components: {
    TableroHeader,
    TableroKanban,
    TableroGantt,
  },
  data() {
    return {
      typesOfBoard: [
        { name: "Kanban", value: "TableroKanban" },
        { name: "Gantt", value: "TableroGantt" },
      ],
      selectedType: "Kanban",
    };
  },
  async mounted() {
    console.log("boardId", this.boardId, "personaId", this.personaId);

    await this.$store.dispatch("lego/getAndSetBoardDeep", {
      boardId: this.boardId,
      personaId: this.personaId,
    });
  },
  beforeDestroy() {
    this.$store.dispatch("lego/cleanBoard");
    this.$store.commit("lego/setShowAllTasks", false); // Actualizar el estado en el store
  },
  computed: {
    typeOfBoard() {
      return this.typesOfBoard.find((type) => type.name == this.selectedType)
        .value;
    },
  },
};
</script>

<template>
  <div class="wrapper">
    <Router-view />
    <TableroHeader class="header" :boardId="boardId">
      <div class="typesBoards">
        <vs-button
          border
          v-for="typeOfBoard in typesOfBoard"
          :active="typeOfBoard.name == selectedType"
          :key="typeOfBoard.value"
          @click="selectedType = typeOfBoard.name"
        >
          <i
            :class="`${
              typeOfBoard.name == 'Kanban'
                ? 'fab fa-trello'
                : 'fas fa-chart-gantt'
            } mr-2`"
            style="font-size: 1rem"
          ></i>
          {{ typeOfBoard.name }}
        </vs-button>
      </div>
    </TableroHeader>

    <component :is="typeOfBoard" />
  </div>
</template>

<style scoped>
.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.typesBoards {
  display: flex;
  align-items: center;
  justify-content: center;

  & button {
    width: 8rem;
  }
}

.header {
  height: 8%;
}
</style>
